import { Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import FileUpload from "./FileUpload";

const FileUploadField = ({
  name,
  control,
  label,
  imageTitle,
  rules,
  disabled = false,
  required = false,
  colProps = { xs: 12, md: 4, lg: 3 },
}) => {
  return (
    <Col {...colProps}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <FileUpload
            {...field}
            label={label}
            imageTitle={imageTitle}
            error={error}
            disabled={disabled}
            required={required}
            onChange={field.onChange}
            errorMessage={error?.message}
          />
        )}
      />
    </Col>
  );
};

export default FileUploadField;
